import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, of, switchMap } from 'rxjs';
import { DigitalProductService } from '../services/digitalProduct.service';
import { digitalProductActions } from './digitalProduct.actions';

@Injectable()
export class DigitalProductEffects {
    constructor(
        private actions$: Actions,
        private digitalProductService: DigitalProductService
    ) { }

    getDigitalProducts$ = createEffect(() => this.actions$.pipe(
        ofType(digitalProductActions.getDigitalProducts),
        switchMap(() => this.digitalProductService.getDigitalProducts().pipe(
            map(digitalProducts => digitalProductActions.getDigitalProductsSuccess(digitalProducts)),
            catchError(error => of(digitalProductActions.getDigitalProductsFailure({ error: error.message })))
        ))
    ));

    getDigitalProduct$ = createEffect(() => this.actions$.pipe(
        ofType(digitalProductActions.getDigitalProduct),
        switchMap(action => this.digitalProductService.getDigitalProduct(action.digitalProductId).pipe(
            map(digitalProduct => digitalProductActions.getDigitalProductSuccess(digitalProduct)),
            catchError(error => of(digitalProductActions.getDigitalProductFailure({ error: error.message })))
        ))
    ));
}
